import styled from "styled-components";
import {UserMenuTitleBox} from "../../user-menu/user-menu/boxes/user-menu-title.box";
import { styledByTheme } from "../../../themes/architecture/styled-by-theme";
import { CssRule } from "../../../themes/architecture/css-helpers/css-rule";

const UserMenuBalanceTitleCasino777Box = styled(UserMenuTitleBox)`
    ${CssRule.For.mobile.build()} &{
        margin: 0;
    }
`;

export const UserMenuBalanceTitleBox = styledByTheme(UserMenuTitleBox).forCasino777(UserMenuBalanceTitleCasino777Box).apply();
